import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Brak tekstu alternatywnego dla tego obrazu',
    noAnswers: "Brak opcji odpowiedzi. Kliknij 'dalej', aby kontynuować.",
    placeholder: 'Proszę sprecyzuj...',
    pleaseSelect: 'Proszę wybrać...',
    rotateLandscape: 'Wyłącz blokadę orientacji na telefonie i obróć go do trybu poziomego.',
    rotatePortrait: 'Obróć telefon z trybu poziomego na tryb portretowy.',
    ir: {
      selectWebCam:
        "Wybierz kamerę internetową (jeśli jest dostępna) lub kliknij 'Przeglądaj', aby wysłać ze swojego urządzenia",
      noWebCam: 'Nie wykryto kamery',
      accessCamUpload: 'KAMERA/WYŚLIJ',
      browse: 'PRZEGLĄDAJ',
      uploadPhoto: 'Wyślij zdjęcie',
      instead: 'zamiast',
      capture: 'PRZECHWYĆ',
      somethingWrong: 'Przepraszamy, coś poszło nie tak. Spróbuj ponownie później',
      couldntRead: 'Przepraszamy, nie udało się odczytać kodu!',
      couldntProcess: 'Przepraszamy, nie udało się przetworzyć obrazu!',
      moveOn: 'Spróbuj ponownie lub prześlij zdjęcie i kontynuuj',
      tryAgain: 'Spróbuj ponownie',
      dataReceived: 'Przesłano dane!',
      enterManually: 'Spróbuj ponownie lub wprowadź dane ręcznie poniżej',
      positionQR:
        'Umieść kod QR przed obiektywem kamery tak, aby znajdował się on w czerwonej ramce, lub wyślij go ze swojego komputera.',
      analyzing: 'Trwa analiza obrazu, proszę czekać',
      submit: 'PRZEŚLIJ',
      startOver: 'Zacznij od nowa',
      allDone: 'Gotowe!',
      cantAnalyze:
        'Uwaga, nie mogliśmy wyrenderować tego obrazu. Spróbuj przesłać ponownie lub wybierz bardziej ogólny format obrazu (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Przepraszamy, nie obsługujemy tego formatu plików. Prześlij obsługiwany typ obrazu (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Nie wykryto kamery',
      uploadVideo: 'Prześlij film',
      skip: 'Pominąć?',
      accessCamUpload: 'KAMERA/WYŚLIJ',
      browse: 'PRZEGLĄDAJ',
      instead: 'zamiast',
      or: 'lub',
      stopRecording: 'Zatrzymaj nagrywanie',
      willBeStopped: 'Nagrywanie zostanie zatrzymane po 5 minutach',
      stopOnDone: 'Zatrzymaj nagrywanie, kiedy skończysz!',
      record: 'NAGRAJ',
      somethingWrong: 'Przepraszamy, coś poszło nie tak. Spróbuj ponownie później',
      microphone: 'Mikrofon',
      camera: 'Kamerę internetową',
      selectMicrophone: 'Wybierz mikrofon',
      selectCam: 'Wybierz kamerę internetową',
      upload: 'Wyślij',
      playback: 'Odtwarzanie',
      stopPlayback: 'ZATRZYMAJ',
      submit: 'PRZEŚLIJ',
      startOver: 'Zacznij od nowa',
      allDone: 'Gotowe!',
      alternativeRecordSpan: 'Prosimy o przesłanie klipu wideo z komputera.<br/>Możesz też nagrać &nbsp;',
      alrenativeRecordHref: ' wideo za pomocą kamery internetowej.',
      cantAnalyze:
        'Uwaga, nie mogliśmy wyrenderować tego wideo. Spróbuj przesłać ponownie lub wybierz bardziej ogólny format wideo (MP4, M4V, WEBPM)',
      wrongFormat:
        'Przepraszamy, nie obsługujemy tego formatu plików. Prześlij obsługiwany typ wideo (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'WYBIERZ',
      pleaseChoose: 'Wybierz',
      this: 'TO',
      one: 'jeden',
      myChoice: 'Mój WYBÓR'
    },
    hm: {
      addComment: 'Dodaj komentarz poniżej',
      commentMandatoryPlaceHolder: 'Dodaj obowiązkowy komentarz… ',
      commentOptionalPlaceHolder: 'Dodaj dodatkowy komentarz… ',
      dragPin: 'Przeciągnij, aby zmienić ułożenie (przytrzymaj kliknięcie / dotknięcie, aby przypiąć dokładniej).',
      removePin: 'Przeciągnij na zewnątrz ilustracji, aby usunąć.',
      editComment: 'Kliknij / dotknij pinezkę, aby edytować komentarz.',
      addPin: 'Przeciągnij pinezkę z poniższego panelu i upuść w wybranym miejscu na ilustracji.',
      addPins: 'Przeciągnij pinezki z poniższego panelu i upuść w wybranym miejscu na ilustracji.',
      leavePins: (minPoints, maxPoints) =>
        `Pozostaw przynajmniej ${minPoints}, lecz nie więcej niż ${maxPoints} pinezek danego rodzaju.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        ` Pozostaw przynajmniej ${minPoints}, lecz nie więcej niż ${maxPoints} pinezek.`,
      leavePinsWithOff: maxPoints =>
        `Pozostaw nie więcej niż ${maxPoints} pinezki danego rodzaju lub kliknij Dalej, aby pominąć.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Pozostaw nie więcej niż ${maxPoints} pinezkę lub kliknij Dalej, aby pominąć.`,
      leavePinWithOff: `Pozostaw nie więcej niż 1 pinezkę danego rodzaju lub kliknij Dalej, aby pominąć.`,
      leavePinPerPageWithOff: 'Pozostaw nie więcej niż 1 pinezkę lub kliknij Dalej, aby pominąć.',
      leaveExactlyPin: 'Pozostaw 1 pinezkę danego rodzaju.',
      leaveExactlyPinPerPage: 'Pozostaw 1 pinezkę.',
      leaveExactlyPins: maxPoints => `Pozostaw ${maxPoints} pinezek danego rodzaju.`,
      leaveExactlyPinsPerPage: maxPoints => `Pozostaw ${maxPoints} pinezki.`,
      leaveComment: 'Aby dodać komentarz, wpisz tekst poniżej ilustracji.',
      noAnswers: 'Brak opcji odpowiedzi, kliknij Dalej, aby kontynuować.',
      outOfPins: 'Skończyły ci się pinezki.',
      pinsBehavior:
        'Przemieszczając się po obrazie będzie można zaobserwować obszary, ktore wyróżnią się przy pomocy jednego upuszczenia pinezki.',
      clusters: 'Będzie można umieścić pinezki tylko w wyróżnionych obszarach.',
      contentAware: 'Można umieścić pinezki wewnątrz lub poza wyróżnionymi obszarami.'
    },
    mp: {
      expand_note: 'Ustaw wskaźnik myszy nad obrazem lub kliknij obraz(y), aby go/je rozwinąć',
      rb_note: rows => `Proszę wybrać tylko 1 odpowiedź w każdej${rows ? ' z poniższych pozycji' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Zaznacz wszystkie, które dotyczą:'
        } else if (min === max) {
          return `Proszę wybrać ${min !== 1 ? 'dowolne' : 'tylko'} ${min} odpowied${min !== 1 ? 'zi' : 'ź'} w każdej${
            rows ? ' z poniższych pozycji' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Proszę wybrać co najmniej ${min} odpowied${
            min !== 1 ? 'zi' : 'ź'
          }, ale nie więcej niż ${max} dotyczącą każdej${rows ? ' pozycji poniżej' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Proszę wybrać co najmniej ${min} odpowied${min !== 1 ? 'zi' : 'ź'} dotyczącą każdej${
            rows ? ' pozycji poniżej' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Proszę wybrać nie więcej niż ${max} odpowied${max !== 1 ? 'zi' : 'ź'} dotyczącą każdej${
            rows ? ' pozycji poniżej' : ''
          }:`
        } else {
          return 'Zaznacz wszystkie, które dotyczą:'
        }
      }
    },
    sh: {
      note: 'Kliknij produkt, aby go powiększyć i dodać do wirtualnego koszyka, jeśli kupił(a)byś go w sklepie',
      amazonNote: 'Kliknij produkt by zbliżyć i dodać go do wirtualnego koszyka.',
      fullCart: 'Twój koszyk jest pełny!',
      qty: 'ILOŚĆ',
      addToCart: 'DODAJ DO KOSZYKA',
      deleteFromCart: 'USUŃ',
      emptyCard: 'Koszyk jest pusty',
      each: 'każdy',
      items: 'rzeczy',
      total: 'Koszyk',
      clearCart: 'Wyczyść koszyk',
      backToStore: 'Wróć do sklepu',
      na: 'Żadne z powyższych',
      next: 'NASTĘPNY',
      maxCartCountError: max => `Dodaj do koszyka nie więcej niż ${max} produktów.`,
      scrollError: `Przewiń do końca w lewo i w prawo, aby przejść do ankiety. `,
      maxSpentError: max => `Nie wydaj więcej niż ${max}.`,
      maxProductCountError: max => `Dodaj do koszyka nie więcej niż ${max} sztuk każdego produktu.`
    },
    rb: {
      note: 'Proszę wybrać tylko 1 pozycję:'
    },
    vo: {
      note: 'Obejrzyj wideo do końca'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Wybierz ${min !== 1 ? 'dowolne' : 'tylko'} ${min} pozycj${min !== 1 ? 'ę' : 'i'}:`
        } else if (min > 0 && max < 5000) {
          return `Wybierz co najmniej ${min} pozycj${min !== 1 ? 'ę' : 'i'}, ale nie więcej niż ${max} na wiersz:`
        } else if (5000 === max && min > 0) {
          return `Wybierz co najmniej ${min} pozycj${min !== 1 ? 'ę' : 'i'}:`
        } else if (0 === min && max < 5000) {
          return `Wybierz nie więcej niż ${max} pozycj${max !== 1 ? 'ę' : 'i'}:`
        } else {
          return 'Zaznacz wszystkie, które dotyczą:'
        }
      }
    },
    oe: {
      na: 'Nie dotyczy',
      note: (min, max, optional) => {
        if (min === max) {
          return `Wpisz ${1 !== min ? 'dowolny' : 'dokładnie'} ${min} znak${1 !== min ? 'e' : ''}${
            optional ? ' (opcjonalny)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Wpisz co najmniej ${min} znak${1 !== min ? 'ów' : ''} but no more than ${max}${
            optional ? ' (opcjonalny)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `?Wpisz co najmniejt ${min} znak${1 !== min ? 'ów' : ''}${optional ? ' (opcjonalny)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Wpisz nie więcej niż ${max} znak${1 !== min ? 'ów' : ''}${optional ? ' (opcjonalny)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Wypełnij następujące pola:'
    },
    mx: {
      note: 'Przesuwaj podświetlone suwaki, aby kontynuować',
      dragSlider: 'Przeciągnij w lewo lub w prawo, aby odpowiedzieć'
    },
    psc: {
      dragLeftRight: 'Przeciągnij w lewo lub w prawo, aby odpowiedzieć'
    },
    ps: {
      note: value => `Rozłóż pozostałe ${value} między przedmiotami poniżej`,
      allDone: 'Gotowe!',
      total: `Całkowity:`,
      dragSlider: 'Przeciągnij w lewo lub w prawo, aby odpowiedzieć'
    },
    cx: {
      note: 'Otwórz listę rozwijaną i zacznij pisać odpowiedź w auto scroll lub wybierz ją ręcznie'
    },
    ro: {
      note: 'Przeciągnij w górę lub w dół, aby zmienić kolejność:'
    },
    md: {
      note1:
        'Kliknij / dotknij przedmiot, który wybierasz jako pierwszy. Kliknij / dotknij ponownie, aby usunąć zaznaczenie',
      note2:
        'Teraz kliknij / dotknij przedmiot, który wybierasz jako ostatni. Kliknij / dotknij ponownie, aby usunąć zaznaczenie',
      note3: 'Dzięki! Przejdź do następnego pytania lub kliknij / dotknij niezaznaczony przedmiot, aby zacząć ponownie.'
    },
    aro: {
      note: 'Wybierz jeden przedmiot dla każdej pary.'
    },
    wd: {
      note: 'Upewnij się, że każda kolejna wartość jest większa niż poprzednia.'
    },
    emd: {
      note: 'Obejrzyj wideo do końca',
      noAnswers: "Brak opcji odpowiedzi. Kliknij 'dalej', aby kontynuować.",
      start: 'Kliknij i przytrzymaj, aby rozpocząć',
      resume: 'Kliknij i przytrzymaj, aby wznowić',
      continue: 'Możesz zaczynać! <br /> Kliknij dalej, aby kontynuować',
      continueMobile: 'Wszystko gotowe! <br /> Kliknij TUTAJ, aby przejść dalej',
      training: {
        session: 'sesja treningowa',
        note: 'Zakończ szkolenie',
        moveLeft: 'Przeciągnij tarczę do końca w lewo',
        moveBottom: 'Przeciągnij tarczę do samego dołu',
        moveRight: 'Teraz przeciągnij tarczę do końca w prawo',
        moveTop: 'A teraz przeciągnij tarczę do samej góry',
        success: 'Dobra robota!'
      }
    },
    sft: {
      noAnswers: "Brak opcji odpowiedzi. Kliknij 'dalej', aby kontynuować.",
      note: 'Odpowiedz tak szybko, jak to możliwe, podając odpowiedź, która intuicyjnie wydaje się właściwa',
      finish: 'Gotowe! <br /> Kliknij dalej, aby kontynuować.',
      training: {
        start:
          '<p>W tym pytaniu będą się szybko wyświetlać różne słowa i będzie ono wymagało koncentracji. ' +
          'Aby odpowiedzieć, musisz szybko zareagować. </p> <p>Możemy zaczynać?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Dotknij "{buttonLeft}"`
            : (mouse ? `Kliknij "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Naciśnij klawisz „F”` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Dotknij "{buttonRight}"`
            : (mouse ? `Kliknij "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Naciśnij klawisz „J”` : ''),
        fail: () => 'Za wolno',
        success: () => 'Świetnie!',
        finish: () =>
          '<p><strong> Doskonale!</strong></p><p>Upewnij się, że przez<br />' +
          'następne 2-3 minuty<br/> nie będziesz się rozpraszać. </p><p>Kliknij Dalej, aby rozpocząć, gdy będziesz gotowy.</p>'
      },
      buttons: {
        start: 'Rozpocznij',
        yesno: {
          left: 'Tak',
          right: 'Nie'
        },
        matches: {
          left: 'Dopasuj',
          right: 'Nie pasuje'
        },
        fits: {
          left: 'Dopasowanie',
          right: 'Brak dopasowania'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
